<app-chips
  [buttonText]="buttonText"
  [dialogTitle]="dialogTitle"
  [hasSelectedState]="hasSelectedFilters"
  #chipsComponent
  class="chips-filter"
  (clear)="resetChipsFilter.emit()"
>
  <ng-content></ng-content>

  <section class="chips-filter__section">
    <button
      app-vtmn-play-button
      type="button"
      (click)="resetAndClose()"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.TERTIARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      [size]="vtmnPlayButtonSize.SMALL"
    >
      {{ 'attendee.chips_filter.button.clear' | translate }}
    </button>

    <button
      app-vtmn-play-button
      type="button"
      class="ml-2"
      (click)="updateAndClose()"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayButtonSize.SMALL"
      [shape]="vtmnPlayButtonShape.SQUARED"
      [disabled]="isValidButtonDisabled ? true : null"
      [attr.data-disabled]="isValidButtonDisabled ? true : null"
    >
      {{ 'attendee.chips_filter.button.update' | translate }}
    </button>
  </section>
</app-chips>
